"use client";

import Link from "next/link";
import { useApp } from "./AppProvider";
import type { ServiceItem } from "@/lib/cms";

interface ServicesProps {
  items: ServiceItem[];
}

export default function Services({ items }: ServicesProps) {
  const { isRTL } = useApp();
  const h = (en: string, ar: string) => isRTL ? (ar || en) : en;

  const gradStyle = (g: 'brand' | 'teal') =>
    g === 'teal'
      ? { grad: "var(--gradient-teal)", shadow: "rgba(7,174,185,0.3)" }
      : { grad: "var(--gradient-brand)", shadow: "rgba(227,1,125,0.3)" };

  return (
    <section id="services" style={{ background: "var(--section-alt-bg)", transition: "background 0.4s ease" }}>
      <div className="container">
        <div style={{ textAlign: "center", marginBottom: "4rem" }}>
          <div className="section-badge" style={{ justifyContent: "center" }}><span>⚡</span> {isRTL ? "ماذا نفعل" : "What We Do"}</div>
          <h2 style={{ fontSize: "clamp(2rem, 4vw, 3rem)", fontWeight: 900, letterSpacing: "-0.02em", marginBottom: "1rem", color: "var(--text-primary)" }}>
            {isRTL ? "خدماتنا" : <>Our <span className="gradient-text-brand">Services</span></>}
          </h2>
          <p style={{ color: "var(--text-muted)", maxWidth: 520, margin: "0 auto", lineHeight: 1.7 }}>
            {isRTL
              ? "كل ما يحتاجه عملك للنجاح في العصر الرقمي."
              : "Everything your business needs to thrive in the digital era."}
          </p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "1.5rem" }}>
          {items.map((s) => {
            const { grad, shadow } = gradStyle(s.gradient);
            return (
              <div key={s.id} className="service-card glass-card" style={{ padding: 0 }}>
                <Link href={`/${s.slug}`} style={{ textDecoration: "none", color: "inherit", display: "block", padding: "2rem" }}>
                  <div style={{ width: 56, height: 56, background: grad, borderRadius: "16px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.5rem", marginBottom: "1.2rem", boxShadow: `0 8px 24px ${shadow}` }}>
                    {s.icon}
                  </div>
                  <h3 className="hover-link" style={{ fontSize: "1.05rem", fontWeight: 700, marginBottom: "0.7rem", color: "var(--text-primary)", textAlign: isRTL ? "right" : "left", transition: "color 0.3s ease" }}>
                    {h(s.title_en, s.title_ar)}
                  </h3>
                  <p style={{ color: "var(--text-muted)", fontSize: "0.88rem", lineHeight: 1.7, textAlign: isRTL ? "right" : "left" }}>
                    {h(s.description_en, s.description_ar)}
                  </p>
                  <div style={{ marginTop: "1.5rem", color: "var(--color-pink)", fontSize: "0.85rem", fontWeight: 600, textAlign: isRTL ? "right" : "left" }}>
                    {isRTL ? "اعرف المزيد ←" : "Learn more →"}
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
